import { MAPBOX_DRAW_MODES } from './draw-modes';
import { MAPBOX_DRAW_STYLES } from './draw-styles';

/** Pixels around pointer used to hit vertices and midpoints (library default: 2). */
export const DRAW_CLICK_BUFFER = 10;

/** Touch hit area in pixels (library default: 25). */
export const DRAW_TOUCH_BUFFER = 35;

/** Shared MapboxDraw options for plot create/edit maps. */
export const MAPBOX_DRAW_PLOT_OPTIONS = {
  boxSelect: false,
  clickBuffer: DRAW_CLICK_BUFFER,
  touchBuffer: DRAW_TOUCH_BUFFER,
  styles: MAPBOX_DRAW_STYLES,
  modes: MAPBOX_DRAW_MODES,
} as const;
